import { render, staticRenderFns } from "./SimplePopup.vue?vue&type=template&id=2209a6c4&scoped=true&"
import script from "./SimplePopup.vue?vue&type=script&lang=ts&"
export * from "./SimplePopup.vue?vue&type=script&lang=ts&"
import style0 from "./SimplePopup.vue?vue&type=style&index=0&id=2209a6c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209a6c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
